var paragraph_default = {
  "fontElementMap": "f54Dh",
  "elementSpacing": "sIWOC",
  "text": "_3yL2P sIWOC",
  "child": "Xj9dt"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
